
import image1_1x from '../../img/covers/Rectangle1_1x.jpg';
import image1_2x from '../../img/covers/Rectangle1_2x.jpg';

import image2_1x from '../../img/covers/Rectangle4_1x.jpg';
import image2_2x from '../../img/covers/Rectangle4_2x.jpg';

import image3_1x from '../../img/covers/Rectangle5_1x.jpg';
import image3_2x from '../../img/covers/Rectangle5_2x.jpg';

import image4_1x from '../../img/covers/Rectangle6_1x.webp';
import image4_2x from '../../img/covers/Rectangle6_2x.webp';

import image5_1x from '../../img/covers/Rectangle7_1x.webp';
import image5_2x from '../../img/covers/Rectangle7_2x.webp';

import image6_1x from '../../img/covers/Rectangle8_1x.jpg';
import image6_2x from '../../img/covers/Rectangle8_2x.jpg';

import image7_1x from '../../img/covers/Rectangle9_1x.webp';
import image7_2x from '../../img/covers/Rectangle9_2x.webp';

import image8_1x from '../../img/covers/Rectangle10_1x.jpg';
import image8_2x from '../../img/covers/Rectangle10_2x.jpg';

import image9_1x from '../../img/covers/Rectangle11_1x.jpg';
import image9_2x from '../../img/covers/Rectangle11_2x.jpg';

import image10_1x from '../../img/covers/Rectangle12_1x.jpg';
import image10_2x from '../../img/covers/Rectangle12_2x.jpg';

export const coverImages = [
  { src1x: image1_1x, src2x: image1_2x, alt: 'Зображення 1' },
  { src1x: image2_1x, src2x: image2_2x, alt: 'Зображення 2' },
  { src1x: image3_1x, src2x: image3_2x, alt: 'Зображення 3' },
  { src1x: image4_1x, src2x: image4_2x, alt: 'Зображення 4' },
  { src1x: image5_1x, src2x: image5_2x, alt: 'Зображення 5' },
  { src1x: image6_1x, src2x: image6_2x, alt: 'Зображення 6' },
  { src1x: image7_1x, src2x: image7_2x, alt: 'Зображення 7' },
  { src1x: image8_1x, src2x: image8_2x, alt: 'Зображення 8' },
  { src1x: image9_1x, src2x: image9_2x, alt: 'Зображення 9' },
  { src1x: image10_1x, src2x: image10_2x, alt: 'Зображення 10' },
];

